import DashboardContainer from "components/Dashboard/DashboardContainer";
import DashboardHeading from "components/Dashboard/DashboardHeading"
import { VendorStaffAnalyticOverview } from "components/Dashboard/VendorStaffAnalyticOverview";
import { useAppMeta } from "hooks";
import React from 'react'
import { useGetStaffPortalDashboardStatsQuery } from "store/services/dashboardApi";

export const VendorStaffDashboardScreen = () => {
    const {
      data: fetchStatsData,
      isLoading: StatsLoading,
      isFetching: fetchingDashboard,
    } = useGetStaffPortalDashboardStatsQuery();
  
    useAppMeta("Staff Dashboard");
  return (
    <DashboardContainer>
      <div>
        <DashboardHeading />
      </div>
      <div>
        <VendorStaffAnalyticOverview
          statsData={fetchStatsData}
          isLoading={StatsLoading || fetchingDashboard}
        />
      </div>
    </DashboardContainer>
  );
}
